var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = Shopify.money_format || "${{amount_with_comma_separator}}";
Shopify.formatMoney = Shopify.formatMoney || function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
    return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));

        this.formType = this.getAttribute('data-type') || null;
        this.instantSubmit = this.getAttribute('data-instant') === 'true';

        this.parameters = [];

        this.state = {};
        this.productMapping = null;

        if (this.querySelector('#twikit-product-mapping') !== null) {
          try {
            this.productMapping = JSON.parse(this.querySelector('#twikit-product-mapping').innerText);
          } catch (e) {
            console.log('Error parsing productMapping', e);
          }
        }

        if (this.formType === 'twikit') {
          this.vendorContainer = this.querySelector('.twikit-vendor');
          this.titleContainer = document.querySelector('[data-product-title]');
  
          this.priceContainer = document.querySelector('.twikit-price-target');
          this.changeWarningContainer = document.querySelector('.product__hidden-price');

          this.twikitPlugin = document.querySelector('twikit-plugin');
          this.twikitLoading = document.querySelector('twikit-loading');
          this.parameters = Array.from(JSON.parse(this.twikitPlugin.dataset['parameters'])).map(item => item.split('|'));

          this.doorReferences = document.querySelectorAll('.field__input--reference');

          /*  Have to confirm with client whether the naming for the weight variant is consistent,
              If yes, we can only manage that selector (product-varriant-picker snippet needs to be updated as well) */
          this.variantInputs = document.querySelectorAll('.product__variant-input input, .product__variant-select option');

          document.addEventListener('twikit:exported', this.handleTwikitResponse.bind(this));
          document.addEventListener('twikit:changed', this.handleTwikitChange.bind(this, false));
        }

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      handleTwikitResponse(event) {
        this.state = event.detail;

        if (this.instantSubmit) {
          this.twikitLoading.classList.remove('hidden');
        }

        for (const input of this.doorReferences) {
          input.value = this.state.doorReference;
          input.dispatchEvent(new Event('input'));
          input.dispatchEvent(new Event('change'));
        }

        this.handleTwikitChange(event.detail.price);

        if (this.instantSubmit) {
          this.querySelector('button[type="submit"]').click();
        }
      }

      async handleTwikit() {
        return new Promise((resolve, reject) => {
          const partitionMapping = {
            "None": "none",
            "Left": "left",
            "Right": "right",
            "Right + Left": "rightleft"
          };

          let productTitle =  this.titleContainer !== null ? this.titleContainer.innerText : 'testing'
          let harmonizedCode = null;
          let countryCodeOfOrigin = null;
          let partitionPosition = 'n/a';
          let doorAmount = 'n/a';

          if (typeof this.state['parameters']['partitionPosition'] !== 'undefined') {
            partitionPosition = partitionMapping[this.state['parameters']['partitionPosition']];
          }

          if (typeof this.state['parameters']['doorAmount'] !== 'undefined') {
            doorAmount = this.state['parameters']['doorAmount'].toLowerCase();
          }

          if (this.productMapping !== null) {
            for (const map of this.productMapping) {
              if (
                map['doorType'] === this.state['parameters']['doorType'] && 
                map['productKey'] === this.state['parameters']['product'] &&
                map['partition'] === partitionPosition &&
                map['amount'] === doorAmount
              ) {
                productTitle = map['ProductTitle'];
                harmonizedCode = map['HSCode'];
                countryCodeOfOrigin = map['CountryOfOrigin'];

                break;
              }
            }
          }

          const formData = {
            'product_title': productTitle,
            'vendor': ''/*this.vendorContainer.innerText*//*TBD*/,
            'price': Number(this.state.price / 100).toFixed(2),
            'product_img': this.state.previewUrl,
            'weight': this.state.weight,
            'country_code_of_origin': countryCodeOfOrigin !== null ? countryCodeOfOrigin : '',
            'harmonized_system_code': harmonizedCode !== null ? harmonizedCode : ''
          };

          fetch('/apps/portapivot/cart/add', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
          }).then(response => {
            return response.json();
          }).then(data => {
            setTimeout(() => {
              this.form.querySelector('[name=id]').value = data.id;
              resolve();
            }, 250);
          }).catch(() => {
            reject();
          });
        });
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();

        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        if (this.formType !== 'twikit') {
          this.handleErrorMessage();
        }

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        if (this.formType === 'twikit') {
          await this.handleTwikit();
        }

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        let foundError = false;

        for (const entry of formData.entries()) {
          const key = entry[0];
          const input = document.querySelector(`[name="${key}"]`);

          if (input && input.required && (!input.value || input.value === 'null' || input.value === '')) {
            if (input.closest('.field')) {
              input.closest('.field').classList.add('field--with-error');
            }

            foundError = true;
          }
        }

        if (foundError) {
          this.handleErrorMessage("Please fill in all required fields");
          this.submitButton.classList.remove('loading');
          this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading__spinner').classList.add('hidden');

          return;
        }

        const errorFields = document.querySelectorAll('.field--with-error');
        
        errorFields.forEach((field) => {
          field.classList.remove('field--with-error');
        });

        const errorMessage = this.querySelector('.product-form__error-message-wrapper');

        if (errorMessage) {
          errorMessage.setAttribute('hidden', true);
        }

        if (this.formType === 'twikit') {
          formData.append('properties[_twikit_image]', this.state.previewUrl);
          formData.append('properties[_pdf_url]', this.state.pdfUrl);
          formData.append('properties[_configurationId]', this.state.configurationId);
          formData.append('properties[_price]', this.state.price);
          formData.append('properties[_weight]', this.state.weight);
          formData.append('properties[_twikit]', JSON.stringify(this.state));

          if (this.productMapping !== null) {
            for (const map of this.productMapping) {
              if (map['doorType'] === this.state['parameters']['doorType'] && map['productKey'] === this.state['parameters']['product']) {
                formData.append('properties[_ProductTitle]', map['ProductTitle']);
                break;
              }
            }
          }

          for (let i = 0; i < this.parameters.length; i++) {
            let name = this.parameters[i][0];

            if (typeof this.state.parameters[name] !== 'undefined' && this.state.parameters[name] != null) {
              let translation = this.parameters[i][1];
              if (this.parameters[i][2].trim() === 'hide') {
                translation = '_' + translation;
              }

              formData.append(`properties[${translation}]`, this.state.parameters[name]);
            }
          }
        }

        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
            if (this.formType === 'twikit') {
              this.twikitLoading.classList.add('hidden');
            }
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      handleTwikitChange(text = false) {
        if (text === false) {
          this.changeWarningContainer.classList.remove('hidden');
          this.submitButton.disabled = true;
          if (this.priceContainer) {
            this.priceContainer.innerText = this.priceContainer.dataset['calculationText'];
            this.priceContainer.removeEventListener
          }
        } else {
          this.changeWarningContainer.classList.add('hidden');
          this.submitButton.disabled = false;
          if (this.priceContainer) {
            this.priceContainer.innerText = Shopify.formatMoney(parseFloat(text));
          }
        }
      }
    }
  );
}
